export default () => ({
    sites: [],
    site: {
        id: -1,
        ndd: 'Tous'
    },
    selectorInput: ''
})
